import type { AdvertisersCategories, AdvertisersCategoriesServer } from '@metapic-apps/shared'

import type {
  AdvertiserListItemServerType,
  AdvertiserListItemType,
  AdvertiserType,
} from '@/lib/types/advertiser.types'
import type { AffiliateLinkServerType, AffiliateLinkType } from '@/lib/types/affiliate-link.types'
import type {
  MoneyServerType,
  MoneyType,
  ProcessableImageType,
  ProcessableServerImageType,
} from '@/lib/types/common.types'

export type ReturnAdFormType = {
  id?: number
  internalName: string
  advertiserGroup: number
  returnLink: string
  advertiserList: AdvertiserListItemType[]
  categories: AdvertisersCategories[]
  isAllAdvertisersSelected: boolean
  status?: ReturnAdStatusEnum
  advertiser?: AdvertiserType
  styles: ReturnAdPreviewStylesType
  image?: ProcessableImageType
  tempImage?: ProcessableImageType
  startsAt?: string
  endsAt?: string
  hasStartsNow: boolean
  hasOpenEnd: boolean
  clickLimit?: number
  viewLimit?: number
  stats?: {
    orderCount: number
    orderValue: MoneyType
    earnings: MoneyType
    currentClicks: number
    currentViews: number
    clickThroughRate: number
  }
}

export type ReturnAdPayloadType = {
  name: string
  advertiser_group_id: number
  return_link: string
  styles: ReturnAdPreviewStylesType
  display_for_all_advertisers: boolean
  advertiser_ids: number[] // Advertisers that return ad will be displayed for
  advertiser_id: number
  advertiser_category_ids: number[]
  image_key?: string | null
  starts_at: string | null
  ends_at: string | null
  click_limit: number | null
  view_limit: number | null
}

export type ReturnAdServerType = {
  id: number
  name: string
  advertiser_group_id: number
  advertiser_categories?: AdvertisersCategoriesServer[]
  author_id: number
  status: ReturnAdStatusEnum
  advertisers?: AdvertiserListItemServerType[]
  affiliate_link: AffiliateLinkServerType
  display_for_all_advertisers: boolean
  styles: ReturnAdPreviewStylesType
  image?: ProcessableServerImageType
  starts_at?: string
  ends_at?: string
  click_limit?: number
  view_limit?: number
  stats: {
    current_clicks: number
    current_views: number
    order_count: number
    order_value: MoneyServerType
    earnings: MoneyServerType
    click_through_rate: number
    conversion_rate?: number
  }
}

export type ReturnAdPreviewType = Omit<
  ReturnAdFormType,
  | 'constraints'
  | 'advertiserList'
  | 'advertiserGroup'
  | 'startsAt'
  | 'endsAt'
  | 'isAllAdvertisersSelected'
  | 'categories'
  | 'internalName'
  | 'returnLink'
  | 'hasStartsNow'
  | 'hasOpenEnd'
  | 'advertiser'
> & { affiliateLink: AffiliateLinkType }

export type ReturnAdPreviewStylesType = {
  text: string
  backgroundType: 'solid' | 'image'
  backgroundColor: string
  textColor: string
  textPosition: 'center' | 'top' | 'bottom'
  buttonBackgroundColor: string
  buttonTextColor: string
}

export enum ReturnAdStatusEnum {
  Ended = 'ended',
  Scheduled = 'scheduled',
  Paused = 'paused',
  Active = 'active',
  Deleted = 'deleted',
}
